import { WeworkCampaignPageParams } from "shared/pages/WeworkCampaignPage";

import { IState } from "..";
import { AnalyticsEvent } from "../../../services/Analytics/AnalyticsConstants";
import FirebaseDatabaseService from "../../../services/firebase/database/FirebaseDatabseService";
import { Dispatch } from "../../store/store";
import MixPanelAnalyticsService from "../../../services/Analytics/MixPanelAnalyticsService";

export const reloadMember = async (
  params: WeworkCampaignPageParams,
  state: IState
) => {
  const { id } = params;
  if (!id || !id.length) {
    const error = `Can't reload member with no id`;
    console.error(error);
    Dispatch.weworkCampaign.reloadMemberFailed(error);
    MixPanelAnalyticsService.trackError({ error });
    return;
  }

  Dispatch.weworkCampaign.reloadingMember(params);
  try {
    const member = await FirebaseDatabaseService.getWeworkMember(params.id);
    Dispatch.weworkCampaign.reloadMemberSucceeded({ member });

    MixPanelAnalyticsService.track(AnalyticsEvent.PageLoaded, {
      page: "Wework Campaign",
      ...member
    });
  } catch (error) {
    const errorMessage = `Failed reloading member ${params.id} ${error}`;
    console.error(errorMessage);
    Dispatch.weworkCampaign.reloadMemberFailed(errorMessage);
    MixPanelAnalyticsService.trackError({ error: errorMessage });
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/wework/WeworkEffects.ts